<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <cf-radio-input
      v-model="tipSelection"
      name="tipSelection"
      :radio-style="customRadioStyle || 'box'"
      allow-uncheck
      :label="label"
      :show-as-optional="showAsOptional"
      :options="tipOptions"
      :validations="{
        required: tipSelectionRequired
      }"
    />

    <transition name="slide-from-top-only-in">
      <cf-text-input
        v-if="tipSelection === 'other'"
        v-model="customTip"
        v-auto-focus
        type="dollars"
        label="Tip Amount"
        name="customTip"
        :allow-negative="false"
        :validations="{
          required: tipSelectionRequired
        }"
      />
    </transition>
  </div>
</template>


<script>
  import dollarsFilter from '@/filters/dollars';

  import CfRadioInput from '@/view/components/shared/cf-radio-input/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';



  export default {
    name: 'CfTipSelectionDefault',

    components: {
      CfRadioInput,
      CfTextInput
    },

    inject: {
      $validator: {
        from: '$validator'
      },

      validatedForm: {
        from: 'validatedForm',
        default() {
          return {};
        }
      }
    },

    props: {
      customRadioStyle: {
        type: String,
        default: null
      },

      label: {
        type: String,
        required: true
      },

      options: {
        type: Array,
        required: true
      },

      showAsOptional: {
        type: Boolean,
        default: false
      },

      tipSelectionRequired: {
        type: Boolean,
        default: false
      },

      total: {
        type: Number,
        required: true
      },

      value: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        customTip: null,
        tipSelection: null
      };
    },

    computed: {
      isDollarAmount() {
        return !!this.options.length && this.options.every(option => Object.prototype.hasOwnProperty.call(option, 'dollarAmount'));
      },

      tipOptions() {
        const result = [];

        this.options.forEach(({ isDefault, percentAmount, dollarAmount }) => {
          const tipOption = {
            isDefault,
            display: `${percentAmount}%`,
            subDisplay: this.getFormattedTipValue(percentAmount),
            value: percentAmount
          };

          if (this.isDollarAmount) {
            Object.assign(tipOption, {
              display: dollarsFilter(dollarAmount, { trimZeros: true }),
              subDisplay: null,
              value: dollarAmount
            });
          }

          result.push(tipOption);
        });

        result.push({
          display: 'Other',
          value: 'other'
        });

        return result;
      }
    },

    watch: {
      customTip: 'tipSelectHandler',
      tipSelection: 'tipSelectHandler',
      total: 'tipSelectHandler'
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.selectDefaultTip();
      },

      getFormattedTipValue(percentage) {
        const tip = Math.round((this.total * (percentage / 100)) * 100) / 100;

        return dollarsFilter(tip);
      },

      selectDefaultTip() {
        const defaultOption = this.tipOptions.find(option => option.isDefault);

        if (defaultOption) {
          this.tipSelection = defaultOption.value;
        }
      },

      tipSelectHandler() {
        let tip = 0;

        if (this.tipSelection === 'other') {
          tip = this.customTip;
        }

        else if (this.tipSelection) {
          if (this.isDollarAmount) {
            tip = this.tipSelection;
          }
          else {
            const percentage = this.tipSelection / 100;
            tip = Math.round((this.total * percentage) * 100) / 100;
          }
        }

        this.$emit('select', tip);
      }
    }
  };
</script>
